import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const TOKEN_KEY = "tp_token";
export const REFRESH_KEY = "tp_refresh";
export const TAILLEUR_KEY = "tp_tailleur";
export const ADMIN_TOKEN_KEY = "tp_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
}

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const isAdmin = (config.url || "").startsWith("/admin");
  const token = isAdmin ? getAdminToken() : getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const isAdmin = (original?.url || "").startsWith("/admin");
    if (error.response?.status === 401 && !original._retry && !isAdmin) {
      const refresh = localStorage.getItem(REFRESH_KEY);
      if (refresh) {
        original._retry = true;
        try {
          if (!refreshing) {
            refreshing = axios
              .post(`${API}/auth/refresh`, { refresh_token: refresh })
              .then((res) => res.data.token)
              .finally(() => (refreshing = null));
          }
          const newToken = await refreshing;
          localStorage.setItem(TOKEN_KEY, newToken);
          original.headers.Authorization = `Bearer ${newToken}`;
          return api(original);
        } catch (e) {
          // fall through
        }
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Une erreur est survenue. Réessayez.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  if (e?.code === "ERR_NETWORK") return "Pas de connexion internet.";
  return fallback;
}

export function isOffline(e) {
  return e?.code === "ERR_NETWORK" || !navigator.onLine;
}
